import type { ProcessorPaymentMethodInfo } from "@btnet/services-btnet/handlers/models/processorPaymentMethodInfo";

import { PaymentBrands, type PaymentMethodType } from "types/enum";

import { PaymentMethod } from "commonComponents/financial/Checkout/Checkout.api.types";

export function mapProcessorPaymentMethodInfoToPaymentMethod(
    data: ProcessorPaymentMethodInfo,
): PaymentMethod {
    return new PaymentMethod({
        merchantPaymentMethodId: data.merchantPaymentMethodId ?? null,
        payerName: data.payerName ?? "",
        paymentBrand: data.paymentBrand ?? PaymentBrands.Unknown,
        paymentType: data.paymentType as PaymentMethodType,
        lastFour: data.lastFour ?? "",
        processorPaymentMethodId: data.processorPaymentMethodId ?? null,
        payerEmail: data.payerEmail ?? null,
        payerPhoneNumber: data.payerPhoneNumber ?? null,
        needsMicrodepositVerification: data.needsMicrodepositVerification ?? false,
        hasMicrodepositsSent: data.hasMicrodepositsSent ?? false,
        isDefault: data.isDefault ?? false,
        institutionName: data.institutionName ?? undefined,
        routingNumber: data.routingNumber ?? undefined,
        isExpired: data.isExpired ?? false,
        feePercent: 0,
        flatFee: 0,
    });
}
